import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  field: {
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.common.gray100,
    },
    // Reveal the row actions on hover (mouse) and on focus-within (keyboard).
    // The actions stay mounted/tabbable at all times so keyboard and screen
    // reader users can always reach them; they are only visually hidden.
    '&:hover $rowActions, &:focus-within $rowActions': {
      opacity: 1,
      pointerEvents: 'auto',
    },
    padding: theme.spacing(1, 2),

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 0),
    },
  },
  rowActions: {
    opacity: 0,
    // Hidden actions must not be clickable — on touch devices a tap goes
    // straight to `click` with no `:hover` phase, which would otherwise let a
    // stray tap trigger an invisible Edit/Copy/Clear. Re-enabled by the
    // `:hover`/`:focus-within` rule once the actions are actually revealed.
    pointerEvents: 'none',
    transition: 'opacity 150ms ease',
  },
  hoverButtonsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  fieldContainer: {
    width: '100%',
  },
  input: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    paddingBottom: theme.spacing(0.5),
    color: theme.palette.common.gray600,
    maxWidth: '75%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  textContent: {
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
  },
  editingFieldButton: {
    maxWidth: theme.spacing(12),
  },
  clearDialogButton: {
    marginLeft: theme.spacing(1),
  },
  fieldHeader: {
    height: theme.spacing(4),
  },
}));

export default useStyles;
